'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	teamConfig = require('@mindmup/mindmup-config/src/team-config'),
	toSharedSubTeam = (sharedWith, sharableTeamMap, fileInfo) => {
		const allowedActions = [],
			canShareMap = fileInfo && fileInfo.allowedActions && fileInfo && fileInfo.allowedActions.share,
			subteam = sharableTeamMap && sharableTeamMap[sharedWith.teamId];
		if (subteam) {
			delete sharableTeamMap[subteam.teamId];
		}
		if (canShareMap || (subteam && subteam.allowedActions && subteam.allowedActions.includes('unshare-map'))) {
			allowedActions.push('unshare-map');
		}
		return {group: 'subteam', affiliateProvider: teamConfig.getAffiliateProvider(sharedWith.teamId), description: sharedWith.description, item: sharedWith, role: sharedWith.sharedAs, allowedActions: allowedActions};
	},
	{ trackEvent } = require('../start/ga-consent');

module.exports = function MapSharingModel(pageController, s3FileModel, subteamApi) {
	if (!pageController || !s3FileModel || !subteamApi) {
		throw new Error('invalid-args');
	}
	let currentSharingList = [], currentTeamMap = {}, sharableTeams = [], fileInfo = false, crowdlink = false, tab = 'gold';
	const obj = observable(this),
		getFileId = () => {
			const fileId = fileInfo && fileInfo.fileId;
			if (!fileId) {
				return Promise.reject('not-loaded');
			}
			return Promise.resolve(fileId);
		},
		buildContext = (activity) => {
			const allowedActions = fileInfo && fileInfo.allowedActions,
				canLoad = !!(allowedActions && !fileInfo.new && !fileInfo.free),
				hasShared = !!(currentSharingList.length),
				hasTeamAccess = !!(currentSharingList.find(item => item.role === 'team access')),
				sharingAllowed = allowedActions && allowedActions.share,
				canInviteSubteam = !!(!hasTeamAccess && sharingAllowed && sharableTeams && sharableTeams.length),
				context = {
					tab,
					canLoad: canLoad,
					canInvite: sharingAllowed,
					canCreateCrowdlink: sharingAllowed,
					canRemove: sharingAllowed && hasShared,
					hasShareList: hasShared,
					sharingList: currentSharingList.slice(0),
					canInviteSubteam: canInviteSubteam,
					sharableSubteams: (canInviteSubteam && sharableTeams) || [],
					crowdlink

				};
			if (activity) {
				context.activity = activity;
			}
			return context;
		},
		sendError = (error) => {
			obj.dispatchEvent('error', error);
			return Promise.reject(error);
		},
		sendContext = (activity) => {
			obj.dispatchEvent('context', buildContext(activity));
		},
		loadSharingInformation = () => {
			const sharableTeamMap = {};

			return subteamApi.listTeams()
			.catch(() => {
				return [];
			})
			.then(teamList => {
				currentTeamMap = {};
				if (teamList && teamList.length) {
					teamList.forEach(subteam => {
						currentTeamMap[subteam.teamId] = subteam;
						if (subteam.allowedActions.includes('share-map')) {
							sharableTeamMap[subteam.teamId] = subteam;
						}
					});
				}
				return getFileId();
			})
			.then((fileId) => {
				sendContext('loading');
				return s3FileModel.getSharedWith(fileId)
				.then((sharingList) => {
					const emailSharingItems = Object.keys(sharingList.direct).map(email => {
							return {group: 'direct', description: email, item: email, role: sharingList.direct[email], allowedActions: ['unshare-map']};
						}),
						subteamSharringItems = sharingList.subteams.map(sharedWith => toSharedSubTeam(sharedWith, sharableTeamMap, fileInfo));
					currentSharingList = emailSharingItems.concat(subteamSharringItems);
				});
			})
			.then(() => {
				sharableTeams = Object.keys(sharableTeamMap).map(key => sharableTeamMap[key]);
			})
			.then(sendContext)
			.catch(reason => {
				if (reason === 'not-found') {
					pageController.redirectToHomePage();
					return;
				}
				return sendError(reason);
			});
		},
		formatCrowdlink = (cl) => {
			if (!cl) {
				return false;
			}
			const expiryLocaleDate = new Date(cl.expiry * 1000).toLocaleString(),
				accessLevels = {
					'collaborator': 'Edit map',
					'viewer': 'Read-only'
				};
			return Object.assign({}, cl, {
				expiryLocaleDate,
				accessLevelLabel: accessLevels[cl.accessLevel] || cl.accessLevel,
				hasPasswordLabel: cl.hasPassword ? 'Link is password protected': 'Not password protected'
			});
		};

	pageController.addEventListener('fileInfo', (newFileInfo) => {
		fileInfo = newFileInfo;
		sendContext();
	});
	obj.load = () => {
		currentSharingList = [];
		return loadSharingInformation();
	};
	obj.shareWithSubteam = (subteam, role) => {
		if (!subteam || !role) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getFileId()
		.then((fileId) => {
			sendContext('saving');
			return s3FileModel.shareWithSubteam(fileId, subteam.teamId, role);
		})
		.then(() => {
			return loadSharingInformation();
		})
		.catch(sendError);

	};
	obj.addMultiple = (sharedEmails, role) => {
		if (!sharedEmails.length) {
			return Promise.reject('no-changes');
		}
		if (!buildContext().canInvite) {
			return false;
		}
		return getFileId()
		.then((fileId) => {
			const shareWith = {};

			sharedEmails.forEach((email) => shareWith[email] = role);
			sendContext('saving');
			return s3FileModel.shareWith(fileId, shareWith);
		})
		.then(() => {
			return loadSharingInformation();
		})
		.catch(sendError);
	};
	obj.removeSharing = (sharedItem) => {
		if (!sharedItem) {
			return Promise.reject('no-changes');
		}
		return getFileId()
		.then((fileId) => {
			if (sharedItem.group === 'direct') {
				const allowedActions = fileInfo && fileInfo.allowedActions,
					shareWith = {};
				sendContext('saving');
				if (allowedActions.share) {
					shareWith[sharedItem.item] = false;
					return s3FileModel.shareWith(fileId, shareWith);
				} else {
					return s3FileModel.removeOwnShare(fileId);
				}
			} else if (sharedItem.group === 'subteam') {
				const teamId = sharedItem.item && sharedItem.item.teamId;
				if (teamId) {
					sendContext('saving');
					return s3FileModel.shareWithSubteam(fileId, teamId);
				}

			}
			throw 'invalid-item';
		})
		.then(() => {
			return loadSharingInformation();
		});
	};
	obj.createPublicUrl = async ({password, timeLimitHours, accessLevel}) => {
		sendContext('Creating Crowd Link');
		const fileKey = pageController.getFileKey(),
			result = await s3FileModel.createPublicUrl({fileKey, password, timeLimitHours, accessLevel});
		trackEvent({
			action: 'map_crowdlink_created',
		});
			
		crowdlink = formatCrowdlink(result);
		sendContext();
	};
	obj.removePublicUrl = async () => {
		sendContext('Removing Crowd Link');
		const fileKey = pageController.getFileKey();
		await s3FileModel.removePublicUrl({fileKey});
		trackEvent({
			action: 'map_crowdlink_removed',
		});
		return obj.showCrowdlink();
	};
	obj.getPublicUrl = async () => {
		const fileKey = pageController.getFileKey(),
			unformatted = await s3FileModel.getPublicUrl({fileKey});

		return formatCrowdlink(unformatted);
	};

	obj.showGoldSharing = () => {
		tab = 'gold';
		sendContext();
	};

	obj.showCrowdlink = async () => {
		tab = 'crowdlink';
		sendContext('Loading Crowd Link info');
		crowdlink = await obj.getPublicUrl();
		sendContext();
	};
};
